import { render } from "./File.vue?vue&type=template&id=4928d4f2"
import script from "./File.vue?vue&type=script&lang=js"
export * from "./File.vue?vue&type=script&lang=js"

import "./File.vue?vue&type=style&index=0&id=4928d4f2&lang=scss"

import exportComponent from "/home/admin/swarm-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__